import { useEffect, useRef } from "react";

export const useWebPubSub = (user, currentStore, onKeys) => {
  const socketRef = useRef(null);
  const onKeysRef = useRef(onKeys);
  const storeId = currentStore?.id;
  const userId = user?.id;

  const handleOnMessage = (event) => {
    try {
      const signalData = JSON.parse(event.data);
      if (Array.isArray(signalData?.events)) {
        if (typeof onKeysRef.current === "function") {
          onKeysRef.current(signalData.events);
        }
      }
    } catch (err) {
      console.error("❌ Failed to parse WebSocket message:", event.data, err);
    }
  };

  useEffect(() => {
    onKeysRef.current = onKeys;
  }, [onKeys]);

  useEffect(() => {
    let isMounted = true;

    if (!storeId) {
      console.warn(
        "⚠️ WebSocket connection skipped: Missing storeId or Shopify is not connected."
      );
      return;
    }

    const connectWebSocket = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}pubsub-negotiation`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ storeId, userId }),
          }
        );

        if (!res.ok) {
          throw new Error(`Negotiation failed: ${res.statusText}`);
        }

        const responseBody = await res.json();
        const { url: storeWebPubSubUrl } = responseBody.storeToken;
        const { url: userWebPubSubUrl } = responseBody.userToken;
        if (!storeWebPubSubUrl) {
          throw new Error("No URL returned from negotiation endpoint");
        }

        const storeSocket = new WebSocket(storeWebPubSubUrl);
        const userSocket = new WebSocket(userWebPubSubUrl);
        socketRef.current = storeSocket;

        storeSocket.onopen = () => console.log("✅ WebSocket connected");
        storeSocket.onerror = (err) =>
          console.error("❌ WebSocket error:", err);
        storeSocket.onclose = () => console.log("🔌 WebSocket closed");
        if (isMounted) {
          storeSocket.onmessage = handleOnMessage;
          userSocket.onmessage = handleOnMessage;
        }
      } catch (error) {
        console.error("❌ Failed to connect WebSocket:", error);
      }
    };

    connectWebSocket();

    return () => {
      isMounted = false;
      if (socketRef.current) {
        socketRef.current.close();
        socketRef.current = null;
      }
    };
  }, [storeId]); // Reconnect when storeId or handler changes
};
